import Swal from 'sweetalert2';
const ErrorSwal = Swal.mixin({
    icon: 'error',
    buttonsStyling: false,
    reverseButtons: true,
    confirmButtonText: 'Ok',
    customClass: {
        confirmButton: 'btn btn-primary',
    },
});
const SuccessSwal = Swal.mixin({
    icon: 'success',
    buttonsStyling: false,
    reverseButtons: true,
    confirmButtonText: 'Ok',
    customClass: {
        confirmButton: 'btn btn-primary',
    },
});
const ConfirmSwal = Swal.mixin({
    icon: 'question',
    buttonsStyling: false,
    reverseButtons: true,
    confirmButtonText: 'Tak',
    showDenyButton: true,
    denyButtonText: 'Nie',
    customClass: {
        denyButton: 'btn btn-warning-light me-2',
        confirmButton: 'btn btn-primary',
    },
});
export { Swal, ErrorSwal, SuccessSwal, ConfirmSwal };
